
export interface DesignerToolSelectEvent {
    add: boolean;
    controlId: string;
  }